import "./AllSegmentsSection.scss";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  FHS_SEGMENTS,
  FHS_SEGMENTS_ADDITIONAL_REGULARITY,
  SUBSCRIPTION,
} from "../../../../../../utils/global";
import { Skeleton } from "primereact/skeleton";
import {
  calculateAPValue,
  formatToDollar,
  getArrowIndicatorClass,
  getBase64FromSource,
  getDifferenceClass,
  getDifferenceClassForFHS,
} from "../../../../../../utils/Utils";
import CustomTooltip from "../../../../../Common/Tooltip/CustomTooltip";
import {
  useGetInsightsAndRecommendationQuery,
  useQueryStateInsightsAndRecommendation,
} from "../../../../../../rtk-query/features/insightsAndRecommendation/insightsAndRecommendationSlice";

export const generateAllSegmentData = async (
  selectedSegmentData,
  segmentList,
) => {
  const filteredSegmentList = Array.isArray(segmentList)
    ? segmentList.filter((segment) =>
        selectedSegmentData?.some((selected) => selected.key === segment.key),
      )
    : [];

  const mergedData = await Promise.all(
    filteredSegmentList.map(async (item1) => {
      const item2 = selectedSegmentData.find((item) => item.key === item1.key);
      const base64Icon = await getBase64FromSource(item1.icon);

      return {
        ...item1,
        ...item2,
        base64Icon,
      };
    }),
  );

  return mergedData.toSorted((a, b) => a.order - b.order);
};

const AllSegmentsSection = ({ showAPValue }) => {
  const [allSegments, setAllSegments] = useState(null);
  const [regulatorySegments, setRegulatorySegments] = useState(null);
  // const fhsDrilldownReducer = useSelector((state) => state.fhsDrilldownReducer);
  const selectedbankMetrics = useSelector(
    (state) => state.infiniteBankPerformanceMetricsReducer,
  );

  const NAV_TABS_ALL_SEGMENT = [
    {
      key: "profitability_and_risk_outlook",
      title: "Profitability & Risk Outlook",
    },
    {
      key: "additional_regulatory_and_risk_metrics",
      title: "Additional Regulatory and Risk Metrics",
    },
  ];
  const [activeTab, setActiveTab] = useState(NAV_TABS_ALL_SEGMENT[0].title);

  useEffect(() => {
    if (!selectedbankMetrics) return;

    const fhs_profitability =
      selectedbankMetrics?.selectedBankMetricData?.profitability;
    const fhs_regularity =
      selectedbankMetrics?.selectedBankMetricData
        ?.additional_regulatory_and_risk_metrics;

    const fetchData = async () => {
      if (fhs_profitability) {
        const allSegmentData = await generateAllSegmentData(
          fhs_profitability,
          FHS_SEGMENTS,
        );
        setAllSegments(allSegmentData);
      } else {
        setAllSegments(null);
      }
    };

    const fetchRegulatoryData = async () => {
      if (fhs_regularity) {
        const allSegmentData = await generateAllSegmentData(
          fhs_regularity,
          FHS_SEGMENTS_ADDITIONAL_REGULARITY,
        );
        setRegulatorySegments(allSegmentData);
      } else {
        setRegulatorySegments(null);
      }
    };

    fetchData();
    fetchRegulatoryData();
  }, [selectedbankMetrics]);

  // useEffect(() => {
  //   //old code
  //   // if (
  //   //   selectedbankMetrics?.selectedBankMetricData?.groupedResult?.all_segments
  //   // ) {
  //   //   const mergedData = FHS_SEGMENTS.map((item1) => {
  //   //     const item2 =
  //   //       selectedbankMetrics?.selectedBankMetricData?.groupedResult?.all_segments?.find(
  //   //         (item) => item.key === item1.key,
  //   //       );
  //   //     return {
  //   //       ...item1,
  //   //       ...item2,
  //   //     };
  //   //   });
  //   //   let allSegmentData = mergedData.toSorted((a, b) => {
  //   //     return a.order - b.order;
  //   //   });

  //   //   setAllSegments(allSegmentData);
  //   // } else {
  //   //   setAllSegments(null);
  //   // }
  // }, [selectedbankMetrics, adjustedMetrics]);

  const segmentsBlock = (segment, index) => {
    return (
      <div
        key={segment.key}
        className={`col-md-3 segments-wrapper d-flex ${(index + 1) % 4 === 1 ? "first-item" : ""} ${(index + 1) % 4 === 0 ? "last-item" : ""} `}
      >
        <div className={`segment ${(index + 1) % 4 !== 0 ? "b-right" : ""}`}>
          <div className="header-content d-flex justify-content-between">
            <div className="context">
              <div className="fs-subtitle">{segment?.title}</div>
              <span className="fs-subdesc">{segment?.description}</span>
            </div>
            <div className="icon">
              <img alt="icon" src={segment?.icon} />
            </div>
          </div>

          <span className="fs-value h-100 align-content-end current_value">
            {segment?.symbol === "$" && segment?.symbol}
            {segment?.symbol === "$" && formatToDollar(segment?.current)}
            {segment?.symbol === "%" && Number(segment.current).toFixed(2)}
            {segment?.symbol === "%" && segment?.symbol}

            {segment?.symbol === "%" ? (
              <CustomTooltip text={`Forecast Variance`} placement="top">
                <span
                  className={`badge trend arrow_value ${getDifferenceClass(segment?.forecasted, segment?.current, segment?.is_reverse)}`}
                >
                  {Math.abs(
                    (segment?.forecasted - segment?.current).toFixed(2),
                  ) ?? 0}
                  %
                </span>
              </CustomTooltip>
            ) : (
              <CustomTooltip text={`Forecast Variance`} placement="top">
                <span
                  className={`badge trend arrow_value ${getDifferenceClass(segment?.forecasted, segment?.current, segment?.is_reverse)}`}
                >
                  {Math.abs(segment?.forecasted_trend) ?? 0}%
                </span>
              </CustomTooltip>
            )}
          </span>
          <div className="footer-content">
            <div className="badges-container">
              {/* {segment?.symbol === "%" ? (
                        <CustomTooltip
                          text={`${getDifferenceMessage(segment?.forecasted - segment?.current ?? 0, "")}`}
                          placement="top"
                        >
                          <span
                            className={`badge trend ${getDifferenceClass(segment?.forecasted - segment?.current, segment?.is_reverse)}`}
                          >
                            {Math.abs(
                              (segment?.forecasted - segment?.current).toFixed(
                                2,
                              ),
                            ) ?? 0}
                            %
                          </span>
                        </CustomTooltip>
                      ) : (
                        <CustomTooltip
                          text={`${getDifferenceMessage(segment?.forecasted_trend ?? 0, segment?.trend_dollar)}`}
                          placement="top"
                        >
                          <span
                            className={`badge trend ${getDifferenceClass(segment?.forecasted_trend, segment?.is_reverse)}`}
                          >
                            {Math.abs(segment?.forecasted_trend) ?? 0}%
                          </span>
                        </CustomTooltip>
                      )}

                      {selectedbankMetrics?.loadingChanges ? (
                        <Skeleton className="skeleton-badge mx-4"></Skeleton>
                      ) : (
                        <CustomTooltip
                          text="Autopilot Forecast"
                          placement="top"
                        >
                          <span className={`badge cohort_average`}>
                            {segment?.symbol === "$" && segment?.symbol}
                            {segment?.symbol === "$" &&
                              formatToDollar(Math.abs(segment?.ap_used || 0))}
                            {segment?.symbol === "%" &&
                              Number(segment?.ap_used).toFixed(2)}
                            {segment?.symbol === "%" && segment?.symbol}
                          </span>
                        </CustomTooltip>
                      )} */}

              {selectedbankMetrics?.loadingChanges ? (
                <Skeleton className="skeleton-badge mx-4"></Skeleton>
              ) : (
                <>
                  {/* old code */}
                  {/* <CustomTooltip
                            text={`${selectedbankMetrics?.selectedBankMetricData?.ungroupedResult?.forecast_quarter} Forecast`}
                            placement="top"
                          >
                            <span className={`badge cohort_average`}>
                              {segment?.symbol === "$" && segment?.symbol}
                              {segment?.symbol === "$" &&
                                formatToDollar(segment?.forecasted || 0)}
                              {segment?.symbol === "%" &&
                                Number(segment?.forecasted).toFixed(2)}
                              {segment?.symbol === "%" && segment?.symbol}
                            </span>
                          </CustomTooltip> */}

                  {/* new code */}
                  <CustomTooltip
                    text={`Forecasted Growth ${Math.abs(segment?.forecasted_trend) ?? 0}%`}
                    placement="top"
                  >
                    <span className={`badge cohort_average`}>
                      <span
                        className={`${getArrowIndicatorClass("isForcasted", showAPValue, segment)}`}
                      ></span>
                      <span className="align-middle">
                        {segment?.symbol === "$" && segment?.symbol}
                        {segment?.symbol === "$" &&
                          formatToDollar(segment?.forecasted || 0)}
                        {segment?.symbol === "%" &&
                          Number(segment?.forecasted).toFixed(2)}
                        {segment?.symbol === "%" && segment?.symbol}
                      </span>
                    </span>
                  </CustomTooltip>

                  {/* old code */}
                  {/* <CustomTooltip
                            text={`${selectedbankMetrics?.selectedBankMetricData?.ungroupedResult?.forecast_quarter} Autopilot Value`}
                            placement="top"
                          >
                            <span
                              className={
                                showAPValue
                                  ? "badge cohort_average autopilot_variance"
                                  : "d-none"
                              }
                            >
                              {segment?.symbol === "$" && segment?.symbol}
                              {segment?.symbol === "$" &&
                                formatToDollar(segment.ap_used)}
                              {segment?.symbol === "%" &&
                                Number(segment.ap_used).toFixed(2)}
                              {segment?.symbol === "%" && segment?.symbol}
                            </span>
                          </CustomTooltip> */}

                  {/* new code */}
                  <CustomTooltip
                    text={`Growth with Autopilot ${Math.abs(segment?.autopilot_trend ?? 0)}%`}
                    placement="top"
                  >
                    <span
                      className={
                        showAPValue
                          ? "badge cohort_average autopilot_variance"
                          : "d-none"
                      }
                    >
                      <span
                        className={`${getArrowIndicatorClass("isAPForcasted", showAPValue, segment)}`}
                      ></span>
                      <span className="align-middle">
                        {segment?.symbol === "$" && segment?.symbol}
                        {segment?.symbol === "$" &&
                          formatToDollar(segment?.final_AP_value)}
                        {segment?.symbol === "%" &&
                          Number(segment?.final_AP_value).toFixed(2)}
                        {segment?.symbol === "%" && segment?.symbol}
                      </span>
                    </span>
                  </CustomTooltip>
                </>
              )}

              {/* {segment?.symbol === "%" ? (
                        <CustomTooltip
                          text={`Forecast Variance`}
                          placement="top"
                        >
                          <span
                            className={`badge trend ms-5 ${getDifferenceClass(segment?.forecasted, segment?.current, segment?.is_reverse)}`}
                          >
                            {Math.abs(
                              (segment?.forecasted - segment?.current).toFixed(
                                2,
                              ),
                            ) ?? 0}
                            %
                          </span>
                        </CustomTooltip>
                      ) : (
                        <CustomTooltip
                          text={`Forecast Variance`}
                          placement="top"
                        >
                          <span
                            className={`badge trend ms-5 ${getDifferenceClass(segment?.forecasted, segment?.current, segment?.is_reverse)}`}
                          >
                            {Math.abs(segment?.forecasted_trend) ?? 0}%
                          </span>
                        </CustomTooltip>
                      )} */}
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    allSegments && (
      <div className="row all-segments-section p-8" id="all-segments-section ">
        {/* <div className="col-md-6">
          <div className="fw-bolder text-dark w-100 fs-title">
            {`Profitability & Risk Outlook for ${
              selectedbankMetrics?.selectedBankMetricData?.forecast_quarter
            }`}
          </div>
        </div> */}
        {/* <div className="col-md-6">
          <span className="remark">Dollar amount in thousands</span>
        </div> */}
        <div className="col-md-12 all-segments-wrapper">
          <div className="row segment-container gy-5">
            <ul class="nav nav-tabs pe-0 mt-0">
              {NAV_TABS_ALL_SEGMENT?.map((item) => {
                return (
                  <li class="nav-item" style={{ marginRight: "1.846rem" }}>
                    <button
                      className={`nav-link ${activeTab === item.title ? "active" : ""}`}
                      onClick={() => setActiveTab(item.title)}
                    >
                      {item.title}
                    </button>
                  </li>
                );
              })}
              <span className="remark ms-auto bd-highlight align-self-center">
                Dollar amount in thousands
              </span>
            </ul>

            <div className="tab-content mt-3">
              <div className="row">
                {activeTab === NAV_TABS_ALL_SEGMENT[0].title &&
                  allSegments?.map((segment, index) => {
                    return segmentsBlock(segment, index);
                  })}
                {activeTab === NAV_TABS_ALL_SEGMENT[1].title &&
                  regulatorySegments?.map((segment, index) => {
                    return segmentsBlock(segment, index);
                  })}
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  );
};

export default AllSegmentsSection;
